import {Component, OnInit} from '@angular/core';
import {Theme} from "../../api/model/theme";
import {AwsService} from "../aws.service";

@Component({
    template: require('./theme-list.component.pug'),
    styles: [require('./theme-list.component.css')]
})
export class ThemeListComponent implements OnInit {
    models: Theme[] = [];

    constructor(private _awsService: AwsService) {
    }

    async ngOnInit() {
        let currentSite = localStorage.getItem('currentSite');
        const additionalParams = {queryParams: {populate: 'user'}};
        this.models = (await this._awsService.api.sitesIdThemesGet({id: currentSite}, {}, additionalParams)).data.items;
    }

    async remove(id:string) {
        let currentSite = localStorage.getItem('currentSite');
        await this._awsService.api.sitesIdPostsThemeIdDelete({id: currentSite, postId: id});
        this.models = (await this._awsService.api.sitesIdThemesGet({id: currentSite})).data.items;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/themes/theme-list.component.ts